import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const aesScSideNav = {
  id: 'sc',
  children: [
    {
      id: 'scDirSalesMenu',
      children: [
        {
          id: 'scDirSaleLines',
          displayName: 'Sale Lines',
          role: 'SC_DIR_SALE_LINE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/dir-sale-line',
          precedence: 2.5,
        },
        {
          id: 'scDirSaleDashboard',
          displayName: 'Sale Dashboard',
          role: 'SC_DIR_SALE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/dir-sale-dashboard',
          precedence: 3,
        },
      ],
    },
    // {
    //   id: 'scBestPrice',
    //   displayName: 'All Best Prices',
    //   role: 'SC_AES_BEST_PRICE_VIEW',
    //   icon: fas.faChartBar,
    //   route: '/sc/aes-best-price',
    //   precedence: 3,
    // },
    {
      id: 'scBestPriceDash',
      displayName: 'Best Prices',
      role: 'SC_AES_BEST_PRICE_VIEW',
      icon: fas.faChartBar,
      route: '/sc/best-price-dashboard',
      precedence: 4,
    },

    {
      id: 'scFilter',
      displayName: 'Global Sales Filters',
      icon: fas.faClipboard,
      route: '/sc/filter',
      role: 'SC_FILTER_VIEW',
      precedence: 37,
      state: { mode: Mode.DETAIL },
    },
  ],
};

export default aesScSideNav;
